import Vue from 'vue';
import Vuex from 'vuex';
import cards from './modules/Study/cards';
import Home from './modules/Home/Home';
import course_info from '@/modules/Course_info/Course_info';
import course from '@/modules/Course/Course';
import testing from './modules/Testing/Testing';
import profile from './modules/Profile/Profile';
import notifications from './modules/Notifications/Notifications';
import news_main from './modules/news/news_main.js';
import news_offer from './modules/news/news_offer.js';
import registration_event from './modules/news/registration_event.js';
import company_profile from './modules/Company_profile/Company_profile';
import autorisation from './modules/Autorisation/autorisation';
import calendar from './modules/calendar/calendar';
import database from './modules/Database/Database';
import contact from './modules/Contact/Contact';
import faq from './modules/FAQ/FAQ';
import ideas_bank from './modules/Ideas_bank/Ideas_bank';
import favourites from './modules/Favourites/Favourites';
import prize_shop from './modules/Prize_shop/Prize_shop';
import rating from './modules/Rating/Rating';
import points_history from './modules/Points_history/Points_history';
import employee_study from './modules/Employee_study/Employee_study';
import users from './modules/Users/Users';
import activity from './modules/Activity/Activity';
import live_news from './modules/Live_news/Live_news';
import events from './modules/Events/Events';
import common from './modules/common/common_module';
import order from './modules/Order/Order';
import authUserData from './modules/AuthUserData/index.js';
import study_plan from './modules/Study_plan/Study_plan';
import knowledge_check from '@/modules/Knowledge_check/Knowledge_check';
import learning_management from '@/modules/LearningManagement/LearningManagement';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  state : {
    first_save: true,
    id        : null,
    isOld     : false,
    isNew     : true,
  },
  getters: {
    first_save    : ({first_save}) => first_save,
    get_auth_token: ({auth_token}) => auth_token,
  },
  mutations: {
    CHANGE_FIRST_SAVE(state, value) {
      state.first_save = value;
    },
  },
  modules: {
    cards, knowledge_check, learning_management, Home, course_info, course, testing, profile, company_profile, autorisation, calendar, news_offer,
    database, contact, faq, ideas_bank, notifications, favourites, news_main, prize_shop, rating, registration_event,
    points_history, employee_study, users, activity, live_news, events, common, order, study_plan, authUserData,
  },
});
